/**
 * Forgot Password Page Loader
 * Tracks page load for password reset flow
 */

import type { LoaderFunctionArgs } from 'react-router-dom';
import {
  trackRouteLoad,
  trackRouteError,
  startRouteTimer,
  calculateDataSize,
} from '@/utils/route-analytics';

export interface ForgotPasswordData {
  email?: string;
}

/**
 * Forgot Password loader function
 */
export async function forgotPasswordLoader(args: LoaderFunctionArgs) {
  const getElapsed = startRouteTimer();

  try {
    // Get any pre-filled email from search params
    const url = new URL(args.request.url);
    const email = url.searchParams.get('email') ?? undefined;

    const data: ForgotPasswordData = {
      email,
    };

    // Track performance
    const loadTime = getElapsed();
    const dataSize = calculateDataSize(data);
    trackRouteLoad('/forgot-password', loadTime, dataSize);

    // Return data directly (React Router loaders don't need to be wrapped)
    return data;
  } catch (error) {
    // If it's a redirect Response, let it propagate
    if (error instanceof Response) {
      throw error;
    }

    trackRouteError('/forgot-password', error as Error);
    throw error;
  }
}
